import { CLIENT_CONTRACT } from "./client_contract"

const pointUpload = CLIENT_CONTRACT.server.trip.pointUpload

export const TRIP_UPLOAD_POLICY = Object.freeze({
  clientPointBatchSize: pointUpload.clientBatchSize,
  serverPointBatchLimit: pointUpload.serverBatchLimit
})

export const CLIENT_POINT_BATCH_SIZE = TRIP_UPLOAD_POLICY.clientPointBatchSize
export const SERVER_POINT_BATCH_LIMIT = TRIP_UPLOAD_POLICY.serverPointBatchLimit

export function serverAllowsClientBatch(policy = TRIP_UPLOAD_POLICY) {
  return policy.serverPointBatchLimit >= policy.clientPointBatchSize
}
